<template>
    <div>
      TradeView
    </div>
  </template>
  
  <script>
  
  export default {
    name: 'TradeView',
  
    components: {
    },
  
    data() {
      return {
      }
    },
  
    methods: {
    }
  };
  </script>
  